import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const withBrowserInfo = connect(s => ({ browser: s.browser }));

const useBrowserInfo = () => useSelector(state => state.browser);

const browserShape = {
  is: PropTypes.shape({
    small: PropTypes.bool,
    large: PropTypes.bool
  })
};

export { browserShape, useBrowserInfo };

export default withBrowserInfo;
